import { gql } from '@apollo/client';
const PLUGIN_NAME = 'chart';
const GET_FILE_BY_ID_QUERY = gql`
  query getFile($id: String!) {
    file: getFile(id: $id) {
      id
      location
      mimetype
      url
      data
      name
      storeKey
      filename
    }
  }
`;
const SUPORTED_COLOUR_SCHEME_PROPS = ['color', 'backgroundColor', 'hoverBackgroundColor', 'borderColor', 'hoverBorderColor', 'borderWidth'];
export { PLUGIN_NAME, GET_FILE_BY_ID_QUERY, SUPORTED_COLOUR_SCHEME_PROPS };
//# sourceMappingURL=constants.js.map